import { render, staticRenderFns } from "./CustomLoader.vue?vue&type=template&id=4f7777bc&scoped=true&"
import script from "./CustomLoader.vue?vue&type=script&lang=js&"
export * from "./CustomLoader.vue?vue&type=script&lang=js&"
import style0 from "./CustomLoader.vue?vue&type=style&index=0&id=4f7777bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7777bc",
  null
  
)

export default component.exports